<template>
  <div>
    <md-dialog
      :md-active.sync="show"
      class="bookprice-filter"
      :md-click-outside-to-close="clickOutside"
    >
      <md-dialog-title>Add Filters</md-dialog-title>

      <div class="layout-dialog" style="display: flex; margin-top: 20px;">
        <div class="left-panel">
          <!-- CUSTOMER -->
          <div class="title-label">
            Book Code
          </div>
          <div>
            <multiselect
              v-model="selectedCustomer"
              id="customer"
              label="label"
              track-by="id"
              placeholder="Search Book Code..."
              :open-direction="'bottom'"
              :options="optionsCustomer"
              :searchable="true"
              :max-height="170"
              :show-no-results="false"
              :custom-label="customLabelCustomer"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="true"
              @select="setDataFilter"
              @close="updateValueAction"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div>
                  <div>{{ option.id }} : {{ option.label }}</div>
                  <div
                    class="-delete"
                    @mousedown.prevent.stop="clearAll(option, 'customer')"
                  >
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>

          <!-- CUSTOMER COMPARE -->
          <div class="title-label" style="margin-top: 34px;">
            Another book code for compare
          </div>
          <div>
            <!-- Compare 1 -->
            <multiselect
              v-model="selectedCustomerComp1"
              id="customerCompare1"
              class="z-index-top"
              label="label"
              track-by="id"
              placeholder="Search Book Code..."
              :open-direction="'bottom'"
              :options="optionsCustomer"
              :searchable="true"
              :max-height="170"
              :show-no-results="false"
              :custom-label="customLabelCustomer"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="true"
              @select="setDataFilter"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div>
                  <div class="-label">
                    <div>{{ option.id }} : {{ option.label }}</div>
                  </div>
                  <div
                    class="-delete"
                    @mousedown.prevent.stop="clearAll(option, 'customerComp1')"
                  >
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </template>
            </multiselect>

            <!-- Compare 2 -->
            <multiselect
              v-model="selectedCustomerComp2"
              id="customerCompare2"
              class="z-index-top"
              label="label"
              track-by="id"
              placeholder="Search Book Code..."
              :open-direction="'top'"
              :options="optionsCustomer"
              :searchable="true"
              :max-height="170"
              :show-no-results="false"
              :custom-label="customLabelCustomer"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="true"
              @select="setDataFilter"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div>
                  <div class="-label">
                    <div>{{ option.id }} : {{ option.label }}</div>
                  </div>
                  <div
                    class="-delete"
                    @mousedown.prevent.stop="clearAll(option, 'customerComp2')"
                  >
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </template>
            </multiselect>

            <!-- Compare 3 -->
            <multiselect
              v-model="selectedCustomerComp3"
              id="customerCompare3"
              class="z-index-top"
              label="label"
              track-by="id"
              placeholder="Search Book Code..."
              :open-direction="'top'"
              :options="optionsCustomer"
              :searchable="true"
              :max-height="170"
              :show-no-results="false"
              :custom-label="customLabelCustomer"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="true"
              @select="setDataFilter"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div>
                  <div class="-label">
                    <div>{{ option.id }} : {{ option.label }}</div>
                  </div>
                  <div
                    class="-delete"
                    @mousedown.prevent.stop="clearAll(option, 'customerComp3')"
                  >
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>

        <div class="right-panel">
          <div class="title-label">
            Product by
          </div>

          <div>
            <!-- TYPE -->
            <multiselect
              v-model="selectedProductType"
              id="type"
              label="title"
              track-by="code"
              placeholder="Search Type"
              :open-direction="'bottom'"
              :options="optionsProductType"
              :searchable="true"
              :max-height="180"
              :show-no-results="false"
              :custom-label="customLabelProduct"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="true"
              @select="setDataProduct"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div>
                  <div>{{ option.code }} - {{ option.title }}</div>
                  <div
                    class="-delete"
                    @mousedown.prevent.stop="clearAll(option, 'type')"
                  >
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </template>
            </multiselect>

            <!-- GROUP -->
            <multiselect
              v-model="selectedProductGroup"
              id="group"
              label="title"
              track-by="code"
              placeholder="Search Group"
              :open-direction="'bottom'"
              :options="optionsProductGroup"
              :searchable="true"
              :max-height="180"
              :show-no-results="false"
              :custom-label="customLabelProduct"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="true"
              @select="setDataProduct"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div>
                  <div>{{ option.code }} - {{ option.title }}</div>
                  <div
                    class="-delete"
                    @mousedown.prevent.stop="clearAll(option, 'group')"
                  >
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </template>
            </multiselect>

            <!-- SUB GROUP -->
            <multiselect
              v-model="selectedProductSubGroup"
              id="subgroup"
              label="title"
              track-by="code"
              placeholder="Search Sub Group"
              :open-direction="'bottom'"
              :options="optionsProductSubGroup"
              :searchable="true"
              :max-height="180"
              :show-no-results="false"
              :custom-label="customLabelProduct"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="true"
              @select="setDataProduct"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div>
                  <div>{{ option.code }} - {{ option.title }}</div>
                  <div
                    class="-delete"
                    @mousedown.prevent.stop="clearAll(option, 'subgroup')"
                  >
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </template>
            </multiselect>

            <!-- CG -->
            <multiselect
              v-model="selectedProductCg"
              id="cg"
              label="title"
              track-by="code"
              placeholder="Search CG"
              :open-direction="'top'"
              :options="optionsProductCg"
              :searchable="true"
              :max-height="180"
              :show-no-results="false"
              :custom-label="customLabelProduct"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="true"
              @select="setDataProduct"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div>
                  <div>{{ option.code }} - {{ option.title }}</div>
                  <div
                    class="-delete"
                    @mousedown.prevent.stop="clearAll(option, 'cg')"
                  >
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>
      </div>

      <md-dialog-actions class="-action">
        <md-button class="md-primary -cancel" @click="onClickCancel()"
          >CANCEL</md-button
        >
        <md-button class="md-primary -filter" @click="onClickFilter()"
          >ADD FILTER</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <dialog-confirm
      :show="showDialogConfirm"
      :content="contentDialog"
      :confirmText="confirmText"
      :cancelText="cancelText"
      @cancel="onCancel()"
      @confirm="onConfirm()"
    ></dialog-confirm>

    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ dContent }}</span>
      <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>

<script>
import BookpriceService from "@/services/bookprice";
import DialogConfirm from "./../../shared/dialog-confirm";

export default {
  name: "bookpriceDialogFilter",

  props: {
    show: {
      type: Boolean,
      required: true
    },
    customer: {
      type: Object,
      required: false
    },
    customer1: {
      type: Object,
      required: false
    },
    customer2: {
      type: Object,
      required: false
    },
    customer3: {
      type: Object,
      required: false
    },
    dataType: {
      type: Object,
      required: false
    },
    dataGroup: {
      type: Object,
      required: false
    },
    dataSubGroup: {
      type: Object,
      required: false
    },
    dataCg: {
      type: Object,
      required: false
    }
  },

  components: {
    DialogConfirm
  },

  watch: {
    show() {
      if (this.show) {
        this.selectedCustomer = [];
        // this.selectedCustomer =
        //   this.customer && this.customer.id === undefined ? [] : this.customer;
        // this.selectedCustomerComp1 =
        //   this.customer1 && this.customer1.id === undefined
        //     ? []
        //     : this.customer1;
        // this.selectedCustomerComp2 =
        //   this.customer2 && this.customer2.id === undefined
        //     ? []
        //     : this.customer2;
        // this.selectedCustomerComp3 =
        //   this.customer3 && this.customer3.id === undefined
        //     ? []
        //     : this.customer3;

        // let key = this.optionsCustomer.findIndex(item => {
        //   return data.id === item.id;
        // });

        // if (key > -1) {
        //   this.optionsCustomer.splice(key, 1);
        // }

        // if (this.clearCustomer1) {
        //   this.selectedCustomerComp1 = [];
        // }
        // if (this.clearCustomer2) {
        //   this.selectedCustomerComp2 = [];
        // }
        // if (this.clearCustomer3) {
        //   this.selectedCustomerComp3 = [];
        // }

        this.selectedProductType =
          this.dataType && this.dataType.code === undefined
            ? []
            : this.dataType;
        this.selectedProductGroup =
          this.dataGroup && this.dataGroup.code === undefined
            ? []
            : this.dataGroup;
        this.selectedProductSubGroup =
          this.dataSubGroup && this.dataSubGroup.code === undefined
            ? []
            : this.dataSubGroup;
        this.selectedProductCg =
          this.dataCg && this.dataCg.code === undefined ? [] : this.dataCg;

        this.dataToken = this.$jwt.decode(localStorage.getItem("token"));

        // BookpriceService.getCustomer({ limit: 9999, all: true }).then(
        //   response => {
        //     response.sort((a, b) => (a.id > b.id ? 1 : -1));
        //     this.optionsCustomer = response;
        //   }
        // );
        BookpriceService.getGroupBookMaster().then(response => {
          response.sort((a, b) => (a.id > b.id ? 1 : -1));
          this.optionsCustomer = response;

          if (this.customer && this.customer.id === undefined) {
            this.selectedCustomer = [];
          } else {
            this.selectedCustomer = this.customer;
            this.setDataFilter(this.customer);
          }

          if (
            this.customer1 === undefined ||
            (this.customer1 && this.customer1.id === undefined)
          ) {
            this.selectedCustomerComp1 = [];
          } else {
            this.selectedCustomerComp1 = this.customer1;
            this.setDataFilter(this.customer1);
          }

          if (
            this.customer2 === undefined ||
            (this.customer2 && this.customer2.id === undefined)
          ) {
            this.selectedCustomerComp2 = [];
          } else {
            this.selectedCustomerComp2 = this.customer2;
            this.setDataFilter(this.customer2);
          }

          if (
            this.customer3 === undefined ||
            (this.customer3 && this.customer3.id === undefined)
          ) {
            this.selectedCustomerComp3 = [];
          } else {
            this.selectedCustomerComp3 = this.customer3;
            this.setDataFilter(this.customer3);
          }
        });

        this.getAllProduct();
      }
    }
  },

  created() {},

  data() {
    return {
      loadData: false,
      clickOutside: false,
      selectedCustomer: [],
      selectedCustomerComp1: [],
      selectedCustomerComp2: [],
      selectedCustomerComp3: [],
      selectedProductType: [],
      selectedProductGroup: [],
      selectedProductSubGroup: [],
      selectedProductCg: [],
      optionsCustomer: [],
      optionsProductType: [],
      optionsProductGroup: [],
      optionsProductSubGroup: [],
      optionsProductCg: [],
      dContent: "",
      showSnackbar: false,
      position: "center",
      duration: 20000,
      isInfinity: false,
      dataToken: [],
      showDialogConfirm: false,
      contentDialog: "",
      confirmText: "OK",
      cancelText: "CANCEL",
      checkEvent: "",
      dataSearch: [],
      selectedValueCus: false
    };
  },

  mounted() {},
  computed: {},

  methods: {
    customLabelType({ id, label }) {
      return `${id} - ${label}`;
    },
    customLabelCustomer({ id, label }) {
      return `${id} : ${label}`;
    },
    customLabelProduct({ code, title }) {
      return `${code} - ${title}`;
    },
    getAllProduct(datas) {
      BookpriceService.getAllProduct(datas)
        .then(response => {
          if (response) {
            this.optionsProductType =
              response.data.type !== undefined
                ? response.data.type.sort((a, b) => (a.code > b.code ? 1 : -1))
                : [];
            this.optionsProductGroup =
              response.data.product_group !== undefined
                ? response.data.product_group.sort((a, b) =>
                    a.code > b.code ? 1 : -1
                  )
                : [];
            this.optionsProductSubGroup =
              response.data.product_subgroup !== undefined
                ? response.data.product_subgroup.sort((a, b) =>
                    a.code > b.code ? 1 : -1
                  )
                : [];
            this.optionsProductCg =
              response.data.product_cg !== undefined
                ? response.data.product_cg.sort((a, b) =>
                    a.code > b.code ? 1 : -1
                  )
                : [];

            if (datas !== undefined && datas.type == "group") {
              this.selectedProductType = response.data.type[0];
            } else if (datas !== undefined && datas.type == "subgroup") {
              this.selectedProductType = response.data.type[0];
              this.selectedProductGroup = response.data.product_group[0];
            } else if (datas !== undefined && datas.type == "cg") {
              this.selectedProductType = response.data.type[0];
              this.selectedProductGroup = response.data.product_group[0];
              this.selectedProductSubGroup = response.data.product_subgroup[0];
            }
          }
        })
        .catch();
    },
    setDataProduct(selectedOption, id) {
      let datas = { type: id, code: selectedOption.code };
      this.getAllProduct(datas);
    },
    setDataFilter(data) {
      let key = this.optionsCustomer.findIndex(item => {
        return data.id === item.id;
      });

      if (key > -1) {
        this.optionsCustomer.splice(key, 1);
      }
      this.selectedValueCus = true;
    },
    updateValueAction(value) {
      if (this.selectedValueCus === true && value !== null) {
        let key = this.optionsCustomer.findIndex(item => {
          return value.id === item.id;
        });

        if (key === -1) {
          this.optionsCustomer.push(value);
          this.optionsCustomer.sort((a, b) => (a.id > b.id ? 1 : -1));
        }
      }
      this.selectedValueCus = false;
    },
    clearAll(item, type) {
      /* CUSTOMER */
      if (type == "customer") {
        this.selectedCustomer = [];
      } else if (type == "customerComp1") {
        this.selectedCustomerComp1 = [];
      } else if (type == "customerComp2") {
        this.selectedCustomerComp2 = [];
      } else if (type == "customerComp3") {
        this.selectedCustomerComp3 = [];
      }
      this.optionsCustomer.push(item);
      this.optionsCustomer.sort((a, b) => (a.id > b.id ? 1 : -1));

      /* PRODUCT */
      if (type == "type") {
        this.selectedProductType = [];
        this.selectedProductGroup = [];
        this.selectedProductSubGroup = [];
        this.selectedProductCg = [];
        this.getAllProduct();
      } else if (type == "group") {
        let datas = { type: "type", code: this.selectedProductType.code };
        this.selectedProductGroup = [];
        this.selectedProductSubGroup = [];
        this.selectedProductCg = [];
        this.getAllProduct(datas);
      } else if (type == "subgroup") {
        let datas = { type: "group", code: this.selectedProductGroup.code };
        this.selectedProductSubGroup = [];
        this.selectedProductCg = [];
        this.getAllProduct(datas);
      } else if (type == "cg") {
        let datas = {
          type: "subgroup",
          code: this.selectedProductSubGroup.code
        };
        this.selectedProductCg = [];
        this.getAllProduct(datas);
      }
    },
    onClickFilter() {
      // if (!this.selectedCustomer || !this.selectedCustomer.id) {
      //   this.showSnackbar = true;
      //   this.dContent = "Please select Customer";
      // } else {
      this.bookPrice = JSON.parse(localStorage.getItem("click_book_price"));
      if (this.bookPrice === null && this.selectedCustomer.id === undefined) {
        this.dContent = "Please select Customer.";
        this.showSnackbar = true;
        return;
      }

      if (
        (this.selectedCustomer &&
          this.selectedCustomer.id !== undefined &&
          this.selectedCustomerComp1 &&
          this.selectedCustomerComp1.id !== undefined &&
          this.selectedCustomer.id === this.selectedCustomerComp1.id) ||
        (this.selectedCustomer &&
          this.selectedCustomer.id !== undefined &&
          this.selectedCustomerComp2 &&
          this.selectedCustomerComp2.id !== undefined &&
          this.selectedCustomer.id === this.selectedCustomerComp2.id) ||
        (this.selectedCustomer &&
          this.selectedCustomer.id !== undefined &&
          this.selectedCustomerComp3 &&
          this.selectedCustomerComp3.id !== undefined &&
          this.selectedCustomer.id === this.selectedCustomerComp3.id)
      ) {
        this.dContent =
          "The Customer is chosen the same as customer for compare.";
        this.showSnackbar = true;
        return;
      }

      if (
        (this.selectedCustomerComp1 &&
          this.selectedCustomerComp1.id !== undefined &&
          this.selectedCustomerComp2 &&
          this.selectedCustomerComp2.id !== undefined &&
          this.selectedCustomerComp1.id === this.selectedCustomerComp2.id) ||
        (this.selectedCustomerComp1 &&
          this.selectedCustomerComp1.id !== undefined &&
          this.selectedCustomerComp3 &&
          this.selectedCustomerComp3.id !== undefined &&
          this.selectedCustomerComp1.id === this.selectedCustomerComp3.id) ||
        (this.selectedCustomerComp2 &&
          this.selectedCustomerComp2.id !== undefined &&
          this.selectedCustomerComp3 &&
          this.selectedCustomerComp3.id !== undefined &&
          this.selectedCustomerComp2.id === this.selectedCustomerComp3.id)
      ) {
        this.dContent = "You have selected the same set of data.";
        this.showSnackbar = true;
        return;
      }

      this.checkEvent = "addfilter";
      this.contentDialog = "Are you sure you want to add filter ?";
      this.showDialogConfirm = true;
      // }
    },
    setDataSearch() {
      let customerComp = [];
      if (
        this.selectedCustomerComp1 &&
        this.selectedCustomerComp1.id !== undefined
      ) {
        customerComp.push(this.selectedCustomerComp1);
      }
      if (
        this.selectedCustomerComp2 &&
        this.selectedCustomerComp2.id !== undefined
      ) {
        customerComp.push(this.selectedCustomerComp2);
      }
      if (
        this.selectedCustomerComp3 &&
        this.selectedCustomerComp3.id !== undefined
      ) {
        customerComp.push(this.selectedCustomerComp3);
      }

      this.dataSearch = {
        customer:
          this.selectedCustomer && this.selectedCustomer.id
            ? this.selectedCustomer
            : "",
        customercomp: customerComp,
        // customercomp1:
        //   this.selectedCustomerComp1 && this.selectedCustomerComp1.id
        //     ? this.selectedCustomerComp1
        //     : "",
        // customercomp2:
        //   this.selectedCustomerComp2 && this.selectedCustomerComp2.id
        //     ? this.selectedCustomerComp2
        //     : "",
        // customercomp3:
        //   this.selectedCustomerComp3 && this.selectedCustomerComp3.id
        //     ? this.selectedCustomerComp3
        //     : "",
        type:
          this.selectedProductType && this.selectedProductType.code
            ? this.selectedProductType
            : "",
        group:
          this.selectedProductGroup && this.selectedProductGroup.code
            ? this.selectedProductGroup
            : "",
        subGroup:
          this.selectedProductSubGroup && this.selectedProductSubGroup.code
            ? this.selectedProductSubGroup
            : "",
        cg:
          this.selectedProductCg && this.selectedProductCg.code
            ? this.selectedProductCg
            : ""
        // start: 0,
        // limit: 20
      };
    },
    onClickCancel() {
      this.checkEvent = "cancel";
      this.contentDialog = "Are you sure you want to cancel ?";
      this.showDialogConfirm = true;
    },
    onCancel() {
      this.showDialogConfirm = false;
    },
    onConfirm() {
      if (this.checkEvent === "cancel") {
        this.$emit("clickCancel");
      } else if (this.checkEvent === "addfilter") {
        this.setDataSearch();
        this.$emit("clickFilter", this.dataSearch);
      }
      this.showDialogConfirm = false;
    }
  },
  beforeDestroy() {}
};
</script>

<style lang="scss">
.bookprice-filter {
  width: 60%;
  max-width: 60% !important;
  height: 70%;
  transform: unset !important;
  top: 15% !important;
  left: 20% !important;

  .md-dialog-title.md-title {
    font-size: 18px;
    margin-bottom: 5px;
    padding: 24px 30px 0;
  }

  .dialog-content {
    padding: 20px;
  }

  .layout-dialog {
    // height: 100%;
    display: block;
    overflow-y: scroll;
    height: calc(70vmin - 125px);
    padding: 0px 30px 5px;

    .title-label {
      padding-left: 5px;
      padding-bottom: 0px;
    }

    .left-panel {
      width: 45%;
      padding-right: 15px;
    }

    .right-panel {
      width: 55%;
      padding-left: 15px;
    }

    .filter-items {
      padding-left: 3px;

      input {
        width: 100%;
        margin: 7px;
        padding-left: 5px;
        padding-right: 5px;
        height: 36px;
        border: 1px solid #ddd;
        border-radius: 5px;
        background: #fff;
      }

      ::placeholder {
        color: #bdbdbd;
        opacity: 1;
      }
    }

    &::-webkit-scrollbar {
      height: 7px;
      width: 5px;
    }
  }

  .-action {
    padding: 8px 20px 10px 24px;
    bottom: 0px;
    margin-right: auto;
    margin-left: auto;
    width: 100%;
    justify-content: flex-end;

    .-cancel .md-button-content {
      color: #727272;
    }

    .-filter {
      color: #3f51b5;
    }
  }

  .multiselect {
    .z-index-top {
      z-index: 10;
    }

    margin: 12px 5px 12px 2px;

    .multiselect__single,
    .multiselect__input {
      font-size: 14px;

      div {
        display: flex;
        width: 100%;

        .-delete {
          width: 5%;
          margin-right: 5px;

          .material-icons {
            font-size: 18px;
            margin-top: 1px;
            cursor: pointer;
            color: gray;
          }
        }
      }
    }

    .multiselect__tags {
      padding: 8px 30px 0 8px;

      ::placeholder {
        color: #bdbdbd;
        opacity: 1;
      }
    }

    .multiselect__content-wrapper {
      // width: 98%;
      font-size: 14px;
      z-index: 10;
    }

    .multiselect__option {
      min-height: 34px;
      padding: 12px 12px 0px 12px;
    }

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
  }
}
</style>
